export const LOGO_URL = "/logo.png";
export const PORTRAIT_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_76fe2749-23d7-4fe4-8097-22560850cf8c/artifacts/q29l5lkv_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2002_34_36%20PM.png";
export const BANNER_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_76fe2749-23d7-4fe4-8097-22560850cf8c/artifacts/kvu19b04_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2005_45_20%20PM.webp";

export const HERO_IMAGE_URL =
  "https://images.unsplash.com/photo-1582576192532-06353147fcbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxicmlkYWwlMjBtYWtldXAlMjBhcnRpc3QlMjBhcHBseWluZyUyMG1ha2V1cCUyMGJyaWRlfGVufDB8fHx8MTc4OTkxMzUyOHww&ixlib=rb-4.1.0&q=85";

export const SAREE_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_velvet-brush/artifacts/cya2gx3z_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2007_42_12%20PM.png";

export const BUSINESS = "The Velvet Brush";
export const TAGLINE = "GRACE. GLAMOUR. YOU.";
export const PHONE = "8318512668";
export const PHONE_LINK = "tel:8318512668";
export const CITY = "Lucknow";
